import React, { useMemo } from "react";

import { ColumnType } from "antd/es/table";
import { defineMessages, IntlShape } from "react-intl";

import { GuideStatus } from "@mapmycustomers/shared";
import { GuideUserStatus } from "@mapmycustomers/shared/types/entity";
import User from "@mapmycustomers/shared/types/User";
import { userDisplayNameComparator } from "@mapmycustomers/shared/util/comparator";
import { userDisplayName } from "@mapmycustomers/shared/util/formatters";

import GuideStatusTag from "../../GuideStatusTag";

const messages = defineMessages({
  name: {
    id: "onboarding.guides.completionDrawer.table.column.name",
    defaultMessage: "User",
    description: "Name of a User column in completion table on Guides  page",
  },
  status: {
    id: "onboarding.guides.completionDrawer.table.column.status",
    defaultMessage: "Guide Completion",
    description: "Name of a Guide Completion column in completion table on Guides  page",
  },
});

const guideStatusPriority: Record<GuideStatus, number> = {
  [GuideStatus.COMPLETED]: 3,
  [GuideStatus.NOT_STARTED]: 1,
  [GuideStatus.PROGRESS]: 2,
};

const guideStatusComparator = (a: GuideStatus, b: GuideStatus) => {
  return guideStatusPriority[a] - guideStatusPriority[b];
};

const useColumns = (intl: IntlShape) =>
  useMemo<ColumnType<GuideUserStatus>[]>(() => {
    return [
      {
        dataIndex: "user",
        render: (user: User) => userDisplayName(user),
        sorter: (a, b) => userDisplayNameComparator(a.user, b.user),
        title: intl.formatMessage(messages.name),
        width: "50%",
      },
      {
        dataIndex: "status",
        render: (status: GuideStatus) => <GuideStatusTag status={status} />,
        sorter: (a, b) => guideStatusComparator(a.status, b.status),
        title: intl.formatMessage(messages.status),
        width: "50%",
      },
    ];
  }, [intl]);

export default useColumns;
